<!-- Start: Rejwan: 14-05-2025 Deregistration (New File) -->
<template>
    <div>
        <div v-if="custom_list.length>0">
            <common-list  :pageurl="this.$api_url" :is_action=1 :checkbox="checkbox"  :is_pf="is_n_pf" :appended_column="appended_column" :key="em_reg_list_key" :company_options="company_options" :employees="custom_list" :default_column="em_reg_default_column" :primary_key="em_reg_primary_key" v-on:childToParent="reg_edit"></common-list>
        </div>
        <div v-else>
            <div v-if="show_loader" class="list-no-data">
                <span class="d-block text-center">Looking for relevant data..</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
            </div>
            <div v-else class="list-no-data">
                Looks like there is no employee to show.
            </div>
        </div>
       

        <gf-profile-overview :pageurl="$api_url" :title="title"  :employee_id="curr_emp_id" :show="show" :is_end="is_end"  :curr_gf_id="curr_gf_id" :key="overview_key" :gf_end_date="gf_end_date" :separation_reason="separation_reason" :joining_date="joining_date" v-on:childToParent="overviewReturn"></gf-profile-overview>
 
        <gf-settlement-form :employee_id ="curr_emp_id" :employee_name="curr_emp_name" :pageurl="$api_url" :settlement_id="settlement_id" :key="settle_form_key" ></gf-settlement-form>
    </div>
</template>
<script>
    export default{
        
        mounted() {
            
            this.showoverlay = false;
        },
        props: ['flg','pageurl','is_action'],
        components: {
     
        },
        data(){            

            return {
                overview_key:0,
                is_end:0,
                title:'',
                show:0,
                min_date:'',
                show_loader:true,
                showoverlay : true,
                errormsg:[],
                curr_gf_id:0, // Rejwan: 19-05-2025 Manual De-registration
                curr_approve_date:'',
                curr_emp_name:'',
                curr_emp_id:0,
                /*new vars */
                pf_from_disable:false,
                people: 0,
                blankmsg: '',
                is_n_pf:1,
                checkbox:1,
                /**Child Component property data */
                appended_column:
                [                 
                    { value: "joining_date", text: "Joining Date",type: "text"},
                    { value: "leaving_date", text: "Leaving Date",type: "text"},
                    { value: "gf_confirmation_date", text: "Confirmation Date",type: "text"},
                    { value: "gf_start", text: "GF Registration Date",type: "text"},
                    { value: "gf_end", text: "GF Deregistration Date",type: "text"},
                    { value: "status", text: "GF Registry Status",type: "text"},
                ],       
                company_options:[],
                custom_list:[],
                em_reg_list_key:0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                em_reg_primary_key:'id',
                em_reg_default_column:['name','employee_code', 'jobposition', 'department', 'branch'], /* Default Column List */
                /***Child Component property data */

                settle_form_key:0,
                settlement_id:0,
                gf_end_date: 0,
                separation_reason: 0,
                joining_date: null,
            }
        },
        methods:{

          
            overviewReturn:function()
            {
                this.$validator.reset();
                this.gfGetRegisteredEmployees();
            },
            gfGetRegisteredEmployees: function(index_name='employee_dropdown')
            {
                let currentObj = this;
                currentObj.show_loader = true;
                axios.get(this.$api_url+'/gf/leaver/list' , {
                    params: {
                        'manual_de_registration': 1
                    }
    
                }).then(function(response){
            
                this.tmp_custom_list = [];

                if (typeof response.data.employee_data !== 'undefined')
                {
                    this.tmp_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));
                }
                if (typeof response.data.options !== 'undefined')
                {
                    /* Assingning the Options */ 
                    this.company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));
                }
            
                /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                
                if(this.tmp_custom_list.length > 0 )
                {
                    let awating_temp = this.tmp_custom_list;
                    let awating_all = [];                 
                    this.tmp_custom_list.forEach(element => {
                            if(element.employee_id > 0)
                            {
                                element.pf_total = this.formatMoney(element.pf_total);
                                let dop = []; 

                                if(element.status == 'Settled')
                                {
                                    element.locked = 1;
                                    dop = dop.concat([{ label: 'Quick View' , value: 4 }]); // Rejwan: 19-05-2025 Manual De-registration
                                } 
                                // Start: Rejwan: 19-05-2025 Manual De-registration
                                // if(element.pf_end != '0000-00-00' && element.pf_end != '')
                                // {
                                    
                                //     dop = dop.concat([{ label: 'Process Settlement' , value: 1 }]);
                                //     dop = dop.concat([{ label: 'Quick View' , value: 4 }]);
                                //     dop = dop.concat([{ label: 'End PF' , value: 3 }]);
                                // }
                                // else
                                // {
                                //     dop = dop.concat([{ label: 'End PF' , value: 3 }]);
                                //     dop = dop.concat([{ label: 'Quick View' , value: 4 }]);
                                    
                                //     element.locked = 0;
                                // }

                                else if(element.gf_end != '0000-00-00' && element.gf_end != '')
                                {
                                    dop = dop.concat([{ label: 'Process Settlement' , value: 1 }]);
                                    dop = dop.concat([{ label: 'Quick View' , value: 4 }]);
                                    dop = dop.concat([{ label: 'Update End Date', value: 5}])
                                }
                                else
                                {
                                    dop = dop.concat([{ label: 'End GF' , value: 3 }]);
                                    dop = dop.concat([{ label: 'Quick View' , value: 4 }]);
                                    
                                    element.locked = 0;
                                }
                                // End: Rejwan: 19-05-2025 Manual De-registration
                                element.actions = dop;

                            }
                        });
                        
                    
                }
                else
                {
                    this.blankmsg = "No employee found as leaver";
                }
                
                this.custom_list = this.tmp_custom_list;

                //this.reg_custom_list = this.reg_tmp_custom_list;
                this.em_reg_list_key = this.em_reg_list_key + 1;
                
                currentObj.show_loader = false;

                }.bind(this)).catch(function (error){

                    currentObj.show_loader = false;
                    console.log(error);
                });
            },
            reg_edit:function(data)
            {   
                this.show = 0;
                this.curr_emp_id =0;
                this.curr_gf_id =0; // Rejwan: 19-05-2025 Manual De-registration
                this.curr_update_id = 0;
                this.curr_approve_date= 0;
                this.curr_update_employee= 0;
                this.gf_end_date = 0;
                this.separation_reason = 0;
                this.joining_date = null;
                if(data.selected.length > 0)
                {
                    this.em_selected = data.selected;
                }
                else
                {
                    this.em_selected = [];
                }
                if(data.id && data.action_id==1)
                {
                    let tmp_list  = this.tmp_custom_list;
                    var item  = tmp_list.find(item => item.id === data.id); 
                    this.curr_emp_name = item.name;
                    this.curr_emp_id = item.employee_id;
                    this.curr_approve_date=item.pf_end;
                    this.settle_form_key += 1;
                }
                if(data.action_id==3)
                {
                    var item  = this.custom_list.find(item => item.id === data.id); 
                    this.curr_gf_id =item.id; // Rejwan: 19-05-2025 Manual De-registration
                    this.curr_emp_id =  item.employee_id;
                    this.show +=  1; 
                    this.is_end =  1; 
                    this.overview_key +=  1;
                    this.joining_date = item.joining_date;
                    this.title =  'GF Employee Grautity Fund End'; 
                }

                if(data.action_id==4)
                {
                    var item  = this.custom_list.find(item => item.id === data.id); 
                    this.curr_gf_id =item.id; // Rejwan: 19-05-2025 Manual De-registration
                    this.curr_emp_id =  item.employee_id;
                    this.show +=  1; 
                    this.is_end =  0; 
                    this.overview_key +=  1;
                    this.title =  'GF Employee Profile Overview'; 
                }

                // Start: Rejwan: 19-05-2025 Manual De-registration
                if(data.action_id==5)
                {
                    var item  = this.custom_list.find(item => item.id === data.id); 
                    this.curr_gf_id =item.id;
                    this.curr_emp_id =  item.employee_id;
                    this.show +=  1; 
                    this.is_end =  2;  // is_end = 2 means i can update gf end date.
                    this.overview_key +=  1;
                    this.gf_end_date = item.gf_end;
                    this.separation_reason = item.separation_reason;
                    this.joining_date = item.joining_date;
                    this.title =  'Update Gratuity End Date'; 
                }
                // End: Rejwan: 19-05-2025 Manual De-registration
            },
            
        },
        created: function(){
            if(!this.checkNet()) return false;
            this.$validator.reset();
            this.gfGetRegisteredEmployees();
        },
        computed: 
        {
            
        }
    }
</script>
<!-- End: Rejwan: 14-05-2025 Deregistration (New File) -->